import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import { Layout } from './components/layout/Layout';
import { Home } from './pages/Home';
import { Portfolio } from './pages/Portfolio';
import { Artists } from './pages/Artists';
import { ArtistDetail } from './pages/ArtistDetail';
import { Shop } from './pages/Shop';
import { ProductDetail } from './pages/ProductDetail';
import { Cart } from './pages/Cart';
import { BookNow } from './pages/BookNow';
import { ReleaseForm } from './pages/ReleaseForm';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
import { Videos } from './pages/Videos';
import { NotFound } from './pages/NotFound';
export function App() {
  return <CartProvider data-id="element-0" data-mp="28u5yeo0zj7dd">
      <BrowserRouter data-id="element-1" data-mp="28tmfp53igeya">
        <Routes data-id="element-2" data-mp="28t4ju9krg2qw">
          <Route element={<Layout data-id="element-4" data-mp="28s2y9b64bxux" />} data-id="element-3" data-mp="28sl511qepuh3">
            <Route path="/" element={<Home data-id="element-6" data-mp="23u9tmmkgrbwr" />} data-id="element-5" data-mp="23vkuadim43jn" />
            <Route path="/portfolio" element={<Portfolio data-id="element-8" data-mp="3ijxpcqos80jw" />} data-id="element-7" data-mp="23ut9zyugts8o" />
            <Route path="/artists" element={<Artists data-id="element-10" data-mp="3ijfvu1ti80fo" />} data-id="element-9" data-mp="3ikr002qv3a7b" />
            <Route path="/artist/:slug" element={<ArtistDetail data-id="element-12" data-mp="3ml1234bj9ggw" />} data-id="element-11" data-mp="3ii4t85bsoyq5" />
            <Route path="/shop" element={<Shop data-id="element-14" data-mp="3mjgclt42snpw" />} data-id="element-13" data-mp="3mjzsz5e2v41t" />
            <Route path="/product/:slug" element={<ProductDetail data-id="element-16" data-mp="3rdkisa5iorpx" />} data-id="element-15" data-mp="3rcj7q5oi4587" />
            <Route path="/cart" element={<Cart data-id="element-18" data-mp="5orh0l86u6j" />} data-id="element-17" data-mp="3reccfffk0fdk" />
            <Route path="/book-now" element={<BookNow data-id="element-20" data-mp="56n1goet9nj" />} data-id="element-19" data-mp="4wvvprmowg9" />
            <Route path="/release-form" element={<ReleaseForm data-id="element-22" data-mp="2zlv3gkrj6jqb" />} data-id="element-21" data-mp="2zl3a7gleoy37" />
            <Route path="/blog" element={<Blog data-id="element-24" data-mp="2znfy0adui2o6" />} data-id="element-23" data-mp="2zmwif0bo3qdb" />
            <Route path="/blog/:slug" element={<BlogPost data-id="element-26" data-mp="33ngiabnml835" />} data-id="element-25" data-mp="33m5cy7ej7s9x" />
            <Route path="/videos" element={<Videos data-id="element-28" data-mp="38m1iwc6shts4" />} data-id="element-27" data-mp="33orla998ybt7" />
            <Route path="*" element={<NotFound data-id="element-30" data-mp="38kgkucl9nspi" />} data-id="element-29" data-mp="38kqafz2efxuo" />
          </Route>
        </Routes>
      </BrowserRouter>
    </CartProvider>;
}